import { CustomerTypes } from "../enums/CustomerType";

import { BRANDS_CATEGORY_ID } from "./BRANDS_CATEGORY_ID";
import { RETAILERS_CATEGORY_ID } from "./RETAILERS_CATEGORY_ID";

export const CATEGORY_ID = {
  [CustomerTypes.RETAILER]: RETAILERS_CATEGORY_ID,
  [CustomerTypes.BRAND]: BRANDS_CATEGORY_ID,
  [CustomerTypes.UNKNOWN]: 0,
};
